import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getBrandByIdSelector } from "../../store";
import classNames from "classnames";
import Button from "../../components/Shared/Controls/Button";
import s from "./style.scss";
import { Link } from "@material-ui/core";
import smimg from "../../../src/resources/images/alarm.png";
import { Button as CustomButton, } from "../../components/Shared/Controls";
import { deletePharmacyAsyncAction, getPatientPharmacyAsyncAction } from "../../store/pharmacy/Sagas";
import { useNavigate } from "react-router";
import LoadingPopUp from "../../components/Shared/LoadingPopUp";
import DeletePopUp from "../../components/Shared/Info/DeletePopUp";
// @ts-ignore
import { t } from "i18next";
import { parsePhoneNumber } from "libphonenumber-js";
const PharmacyList = ({ patientId, getPatientPharmacyAction, getPatientPharmacyData, requestGetPharmacyStatus, requestDeletePharmacyStatus, deletePharmacyAction }) => {
    const navigate = useNavigate();
    const [infoIsOpen, setDisplayInfo] = useState(false);
    const brand = useSelector(getBrandByIdSelector);
    const phoneNumber = getPatientPharmacyData?.[0] == null || getPatientPharmacyData?.[0]?.phone == "" ? null
        : parsePhoneNumber('+1' + getPatientPharmacyData?.[0]?.phone);
    useEffect(() => {
        getPatientPharmacyAction({ patientId });
    }, []);
    const OpenMapPage = () => {
        navigate('/pharmacy/select-pharmacy');
    };
    const deletePharmacy = () => {
        setDisplayInfo(true);
    };
    const updatePharmacy = () => {
        if (getPatientPharmacyData) {
            if (getPatientPharmacyData?.[0]?.latitude == 0 && getPatientPharmacyData?.[0]?.longitude == 0) {
                navigate('/pharmacy/add-pharmacy/add-my-own-pharmacy');
            }
            else {
                navigate('/pharmacy/select-pharmacy');
            }
        }
    };
    const handleDeleteInfo = (Id) => {
        deletePharmacyAction(Id);
    };
    const getGoogleMapsLink = () => {
        if (getPatientPharmacyData?.[0]?.latitude && getPatientPharmacyData?.[0]?.longitude) {
            let link = `https://www.google.com/maps/search/${getPatientPharmacyData?.[0]?.latitude}, ${getPatientPharmacyData?.[0]?.longitude}/@${getPatientPharmacyData?.[0]?.latitude},${getPatientPharmacyData?.[0]?.longitude},10z`;
            return link;
        }
        let link = `https://www.google.com/maps/search/${getPatientPharmacyData?.[0]?.address}`;
        if (!!getPatientPharmacyData?.[0]?.city) {
            link += ` ${getPatientPharmacyData?.[0]?.city}`;
        }
        if (!!getPatientPharmacyData?.[0]?.country) {
            link += ` ${getPatientPharmacyData?.[0]?.country}`;
        }
        if (!!getPatientPharmacyData?.[0]?.postal) {
            link += ` ${getPatientPharmacyData?.[0]?.postal}`;
        }
        return link;
    };
    useEffect(() => {
        if (requestDeletePharmacyStatus === "success") {
            setDisplayInfo(false);
            getPatientPharmacyAction({ patientId });
        }
    }, [requestDeletePharmacyStatus]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames(s.pageBody, s.profileWrapper, s.scrollWrapper, s.w100) },
            React.createElement("h3", null, t("pharmacy")),
            React.createElement("div", { className: classNames(s.remindersPageWrapper) }, getPatientPharmacyData?.length > 0 ?
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classNames(s.pharmacyAddboxAll) },
                        React.createElement("div", { className: classNames(s.pharmacyAddbox) },
                            React.createElement("img", { src: brand.logoLink, className: s.brandLogo }),
                            React.createElement("h3", null, getPatientPharmacyData?.[0]?.name),
                            React.createElement("ul", null,
                                React.createElement("li", null, getPatientPharmacyData?.[0]?.address),
                                React.createElement("li", null, getPatientPharmacyData?.[0]?.city),
                                React.createElement("li", null, getPatientPharmacyData?.[0]?.country),
                                React.createElement("li", null, phoneNumber?.formatInternational())),
                            getPatientPharmacyData?.[0]?.latitude == 0 && getPatientPharmacyData?.[0]?.longitude == 0
                                ? null :
                                React.createElement("div", { className: classNames(s.GetDirectionsbox) },
                                    React.createElement("div", { className: classNames(s.GetDirectionsboxtext) },
                                        React.createElement(Link, { href: getGoogleMapsLink(), target: "_blank", className: s.GetDirectionsboxlink }, t("viewOnMap"))),
                                    React.createElement("div", { className: classNames(s.GetDirectionsboxImg) },
                                        React.createElement("img", { src: smimg, className: "img-fluid" })))),
                        React.createElement("div", { className: s.buttonTwopage },
                            React.createElement(CustomButton, { text: t("delete"), onClick: deletePharmacy }),
                            React.createElement(CustomButton, { style: s.mb0_button, primary: true, text: t("change"), onClick: updatePharmacy }))))
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classNames(s.pharmacybox) },
                            React.createElement("img", { src: brand.logoLink, className: s.brandLogo }),
                            React.createElement("h2", null, "You have no Pharmacies yet"),
                            React.createElement(Button, { style: s.button, primary: true, iosTextOverflow: true, text: "Add Pharmacy", onClick: OpenMapPage }))))),
        React.createElement(DeletePopUp, { isOpen: infoIsOpen, togglePopUp: () => setDisplayInfo(false), onClick: () => handleDeleteInfo(getPatientPharmacyData?.[0]?.patientBrandPharmacyId), header: t("deletePermanently") }),
        requestGetPharmacyStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null,
        requestDeletePharmacyStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null));
};
const mapStateToProps = (state) => {
    return {
        patientId: state.account.user.patientId ?? "",
        getPatientPharmacyData: state.pharmacy.getPharmacyData,
        requestGetPharmacyStatus: state.pharmacy.requestGetPharmacyStatus,
        requestDeletePharmacyStatus: state.pharmacy.requestDeletePharmacyStatus
    };
};
function mapDispatchToProps(dispatch) {
    return {
        getPatientPharmacyAction: (data) => dispatch(getPatientPharmacyAsyncAction(data)),
        deletePharmacyAction: (Id) => dispatch(deletePharmacyAsyncAction(Id)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PharmacyList);
